/* tslint:disable */
/* eslint-disable */
/**
 * Jobs API
 * Backend de bolsa de trabajo para alumno, empresa y admin.  Pantallas de Alumno [P_A_xx]   https://app.axure.cloud/app/project/5t0fsq/overview  Pantallas de empresa [P_E_xx]    https://app.axure.cloud/app/project/jcj3w8/overview
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Default response with a pair status-message
 * @export
 * @interface DefaultResponse
 */
export interface DefaultResponse {
    /**
     * 
     * @type {string}
     * @memberof DefaultResponse
     */
    status?: string;
    /**
     * 
     * @type {string}
     * @memberof DefaultResponse
     */
    msg?: string;
}

export function DefaultResponseFromJSON(json: any): DefaultResponse {
    return DefaultResponseFromJSONTyped(json, false);
}

export function DefaultResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DefaultResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': !exists(json, 'status') ? undefined : json['status'],
        'msg': !exists(json, 'msg') ? undefined : json['msg'],
    };
}

export function DefaultResponseToJSON(value?: DefaultResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'msg': value.msg,
    };
}


